import React from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import 'primeicons/primeicons.css';
import StoreModal from "./StoreModal";

class ListModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            selectedUser: null,
            isEditingName: false,
            editedName: ''
        };
    }

    actionBodyTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-pencil"
                className="p-button-text p-button-secondary"
                style={{ color: '#6c757d' }}
                onClick={() => this.setState({ show: true, selectedUser: rowData })}
            />
        );
    }

    startEditing = () => {
        this.setState({
            isEditingName: true,
            editedName: this.props.selectedOverlay?.name || ''
        });
    }

    saveName = () => {
        if (this.props.selectedOverlay) {
            this.props.selectedOverlay.name = this.state.editedName;
        }
        this.setState({ isEditingName: false });
    }

    renderHeaderContent = () => {
        if (this.state.isEditingName) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <InputText
                        value={this.state.editedName}
                        onChange={(e) => this.setState({ editedName: e.target.value })}
                        onKeyDown={(e) => e.key === 'Enter' && this.saveName()}
                        onBlur={this.saveName}
                        autoFocus
                        style={{ fontWeight: 'bold', fontSize: '1.5rem' }}
                    />
                    <i className="pi pi-check" style={{ cursor: 'pointer', fontSize: '1rem', color: 'green' }} onClick={this.saveName}></i>
                </div>
            );
        }
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={styles.title}>{this.props.selectedOverlay?.name}</span>
                <i className="pi pi-pencil" style={{ cursor: 'pointer', fontSize: '1rem', color: '#6c757d' }} onClick={this.startEditing}></i>
            </div>
        );
    }

    render() {

        return (
            <>

                <Dialog
                    header={this.renderHeaderContent}
                    visible={this.props.show}
                    modal
                    closable
                    onHide={this.props.onHide}
                    className="importar-dialog"
                    style={{ width: '90vw', maxWidth: '70%', marginTop: '2%' }}
                    contentStyle={{ padding: '0' }}
                >
                    <div className="p-4">
                        <DataTable
                            value={this.props.selectedOverlay?.meta_data_users}
                            responsiveLayout="scroll"
                            className="p-datatable-sm"
                            emptyMessage="Nenhum registro encontrado."
                            rowHover
                            style={{ border: 'none' }}
                            scrollable
                            scrollHeight="60vh"
                        >
                            <Column field="user_type" header="TIPO DE USUÁRIO" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="cep" header="CEP" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="age" header="IDADE" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="genre" header="GÊNERO" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="marital_status" header="ESTADO CIVIL" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="children" header="FILHOS" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="income" header="RENDA" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="property_of_interest" header="EMPREENDIMENTO" style={styles.column} headerStyle={styles.header}></Column>
                            <Column field="typology_of_interest" header="TIPOLOGIA DE INTERESSE" style={styles.column} headerStyle={styles.header}></Column>
                            <Column body={this.actionBodyTemplate} header="AÇÕES" style={{ width: '80px', textAlign: 'center' }} headerStyle={styles.header}></Column>
                        </DataTable>
                    </div>
                </Dialog>

                <StoreModal
                    show={this.state.show}
                    user={this.state.selectedUser}
                    toast={this.props.toast}
                    reloadBuildings={this.props.reloadBuildings}
                    onHide={() => this.setState({ show: false, selectedUser: null })}
                />
            </>
        );
    }
}

const styles = {
    header: {
        textTransform: 'uppercase',
        fontSize: '0.75rem',
        color: '#5b595b',
        fontWeight: '700',
        borderBottom: '1px solid #f0f0f0',
        padding: '1rem',
        fontFamily: 'Archivo Expanded bold'
    },
    column: {
        color: '#5b595b',
        fontSize: '0.9rem',
        padding: '1rem',
        fontFamily: 'Archivo Expanded bold'

    },
    title: {
        fontWeight: 'bold',
        fontSize: '1.5rem',
        fontFamily: 'Archivo Expanded bold'
    }
};

export default ListModal;